// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"244053d9","142":"c8029d9e"}[chunkId] + ".chunk.js";
};